<template>
  <div class="flex flex-between px-3 pb-5">
    <router-link to="/adoption#info-adoption" class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-navigation 
            rounded-lg hover:bg-primaire focus:ring-4 focus:outline-none focus:ring-primaire 
            dark:primaire dark:hover:bg-primaire dark:focus:ring-primaire" aria-label="En savoir plus sur l'adoption !" title="En savoir plus sur l'adoption !">
      Info adoption
      <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 14 10">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M1 5h12m0 0L9 1m4 4L9 9" />
      </svg>
    </router-link>
  </div>
</template>